"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSpamContent = getSpamContent;
exports.getSpamContentCount = getSpamContentCount;
exports.isSpam = isSpam;
exports.markPostsAsNotSpam = markPostsAsNotSpam;
exports.markPostsAsSpam = markPostsAsSpam;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

var _globals = require("@insided/shared/utils/globals");

function getSpamContentCount() {
  return _getSpamContentCount.apply(this, arguments);
}

function _getSpamContentCount() {
  _getSpamContentCount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _axios.default.get('/community/api/spamContent/count');

          case 2:
            return _context.abrupt("return", _context.sent);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getSpamContentCount.apply(this, arguments);
}

function getSpamContent(_x) {
  return _getSpamContent.apply(this, arguments);
}

function _getSpamContent() {
  _getSpamContent = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(_ref) {
    var _ref$pagination, _ref$pagination2, page, pageSize, searchParams, response;

    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _ref$pagination = _ref.pagination, _ref$pagination2 = _ref$pagination === void 0 ? {
              page: 1,
              pageSize: 25
            } : _ref$pagination, page = _ref$pagination2.page, pageSize = _ref$pagination2.pageSize;
            searchParams = new URLSearchParams({
              page: String(page),
              pageSize: String(pageSize)
            });
            _context2.next = 4;
            return _axios.default.get("/community/api/spamContent?".concat(searchParams));

          case 4:
            response = _context2.sent;
            return _context2.abrupt("return", {
              data: response.data.result,
              total: response.data._metadata.totalCount
            });

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getSpamContent.apply(this, arguments);
}

function markPostsAsSpam(_x2) {
  return _markPostsAsSpam.apply(this, arguments);
}

function _markPostsAsSpam() {
  _markPostsAsSpam = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(posts) {
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _axios.default.post('/community/api/bulk/process', {
              action: 'markAsSpam',
              topics: posts
            });

          case 2:
            _context3.next = 4;
            return _axios.default.post('/community/api/invalidateCache?apiPath=spamContent/count');

          case 4:
            (0, _globals.publish)('posts_marked_as_spam', {});

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _markPostsAsSpam.apply(this, arguments);
}

function markPostsAsNotSpam(_x3) {
  return _markPostsAsNotSpam.apply(this, arguments);
}

function _markPostsAsNotSpam() {
  _markPostsAsNotSpam = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(posts) {
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _axios.default.post('/community/api/bulk/process', {
              action: 'markAsNotSpam',
              topics: posts
            });

          case 2:
            _context4.next = 4;
            return _axios.default.post('/community/api/invalidateCache?apiPath=spamContent/count');

          case 4:
            (0, _globals.publish)('posts_marked_as_not_spam', {});

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _markPostsAsNotSpam.apply(this, arguments);
}

function isSpam(_x4, _x5, _x6) {
  return _isSpam.apply(this, arguments);
}

function _isSpam() {
  _isSpam = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(id, contentType, isReply) {
    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _axios.default.post('/community/api/spamContent/isSpam', {
              id: id,
              contentType: contentType,
              isReply: isReply
            });

          case 2:
            return _context5.abrupt("return", _context5.sent);

          case 3:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _isSpam.apply(this, arguments);
}